import {combineReducers} from "redux";
import playShift from "./playShift";
import rebates from "./rebates";
import lotteryType from "./lotteryType";
import shift from "./shift";
import drawingShift from "./drawingShift";
import lotteryUser from "./lotteryUser";
import lotteryShift from "./lotteryShift";
import configShift from "./configShift";
import minuteRender from "./minuteRender";
import userHasShift from "./userHasShift";


const gameConfigReducer = combineReducers({
    playShift,
    rebates,
    lotteryType,
    shift,
    drawingShift,
    lotteryUser,
    lotteryShift,
    configShift,
    minuteRender,
    userHasShift
});
export default gameConfigReducer;

